import { ChangeEvent, InvalidEvent, JSX } from "react";
import { FileInputField, Notice } from "@hatch-digital-nl/abs-storybook/legacy";
import { Dispatch } from "redux";
import { useState } from "react";
import { setError, setFormValues } from "../../CreateCertificateModalSlice";

interface Props {
    id: number;
    formValues?: {
        fileName: string;
    };
    dispatch: Dispatch;
    setFile: (file: File | null) => void;
    showNotice?: boolean;
    noticeText?: string;
    className?: string;
}

export const FileInputFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        formValues,
        dispatch,
        setFile,
        showNotice,
        noticeText,
        className,
    } = props;
    const [fileError, setFileError] = useState<{
        [key: string]: string | null;
    }>({});
    let newClassName = "c-edit-certificate-modal__form-group";

    if (className) {
        newClassName = className;
    }

    return (
        <div className={newClassName}>
            <label htmlFor={`file-upload-${id}`}>Upload certificaat</label>
            <FileInputField
                placeHolder={"Bestand uploaden (max. 3mb)"}
                maxFileSizeInMb={3}
                inputId={id}
                fileName={formValues?.fileName}
                required={true}
                onDeleteClick={() =>
                    dispatch(setFormValues({ ...formValues, fileName: "" }))
                }
                onChange={({
                    event,
                    error,
                }: {
                    event: ChangeEvent<HTMLInputElement>;
                    error: string | null;
                }) => {
                    if (fileError[id]) {
                        setFileError((prevErrors) => ({
                            ...prevErrors,
                            [id]: null,
                        }));
                    }

                    if (error) {
                        dispatch(setError(error));
                        setFile(null);
                        setFileError((prevErrors) => ({
                            ...prevErrors,
                            [id]: error,
                        }));
                        return;
                    }
                    const files = event?.target?.files;
                    if (files && files.length > 0) {
                        const file = files[0];
                        if (file.size < 3 * 1024 * 1024) {
                            setFile(file);
                            dispatch(setError(null));
                            setFileError((prevErrors) => ({
                                ...prevErrors,
                                [id]: null,
                            }));
                        }
                    }
                }}
                onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                    event.preventDefault();

                    if (
                        (event.target as HTMLInputElement).validity.valueMissing
                    ) {
                        setFileError((prevErrors) => ({
                            ...prevErrors,
                            [id]: "Certificaat ontbreekt",
                        }));
                    }
                }}
            />
            {fileError[id] && (
                <p className={"c-error-message"}>{fileError[id]}</p>
            )}
            {showNotice && noticeText && (
                <div
                    className={"c-create-certificate-modal__form-group__notice"}
                >
                    <Notice htmlContent={`<p>${noticeText}</p>`} />
                </div>
            )}
        </div>
    );
};
